<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.reports'), $t('reports.synthesizeCostProfit')]"
      >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="100px"
      >
        <el-form-item
          :label="$t('settlement.dateType')"
          :prop="'_dateType'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateType')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group size="small" v-model="searchForm._dateType">
            <el-radio label="createAt">{{ $t("text.createAt") }}</el-radio>
            <el-radio label="deliverAt">{{
              $t("delivery.deliverAt")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item
          :label="$t('settlement.dateRange')"
          :prop="'_dataRange'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateRange')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="_dataRange"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <!-- <el-form-item :label="$t('product.productNo')">
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <br />
        <el-form-item :label="$t('product.color')">
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.color"
            :fetch-suggestions="querySearchColor"
            style="width: 100%"
            @select="handleSelectColor"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <br /> -->

        <el-form-item
          :label="$t('salesTarget.userName')"
          v-if="users.length != 0"
        >
          <el-checkbox-group v-model="searchForm.ownerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br v-if="users.length != 0" />
        <el-form-item :label="$t('menu.shops')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('product.productNo')">
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('menu.suppliers')">
          <el-select
            size="small"
            v-model="searchForm.supplierId"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
            <span v-if="count != null" class="pager-total">
              {{ count.productNoQty }} 款 {{ count.qtyTotal }} 件,销售总额:{{
                count.productAmount | currency
              }},总成交额:{{ count.cnyAmount | currency }},总产品成本:{{
                count.costTotalAmount | currency
              }},总发货成本:{{ count.deliverCostAmount | currency }},总利润:{{
                count.profitAmount | currency
              }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column type="expand" width="30px">
          <template v-slot:content="{ row }">
            <vxe-table
              :data="row.orders"
              ref="ordersTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="85"
              >
                <template v-slot="{ row }">
                  <thumbnail :images="row.images"></thumbnail>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('order.serialNo')"
                min-width="140"
              >
                <template v-slot="{ row }">
                  <small v-if="row.hurry" class="red">
                    ({{ $t("order.hurrySimple") }})
                  </small>
                  {{ row.serialNo }}
                  <div class="font10">{{ row.innerSerialNo }}</div>
                  <div class="font10">
                    <state-label :state="row.workflowState">
                      {{ $t("orderStates." + row.workflowState) }}
                    </state-label>
                    <span v-if="row.pauseAt != null" class="orange mgr5">
                      {{ $t("dealInfos.pause") }}
                    </span>
                    <span v-if="row.bargainId == null" class="orange mgr5">
                      {{ $t("order.replenish") }}
                    </span>
                  </div>
                  <div class="font10">
                    {{ $t("order.price") }}
                    <currency :code="row.currency"></currency>
                    {{ row.price }}
                    <span v-if="row.currency !== 'CNY'">
                      ({{ row.cnyPrice | currency }})
                    </span>
                  </div>
                  <div
                    v-if="row.extraCharge != null && row.extraCharge != 0"
                    class="font10"
                  >
                    {{ $t("order.extraCharge") }}
                    <currency :code="row.currency"></currency>
                    {{ row.extraCharge }}
                    <span v-if="row.currency !== 'CNY'">
                      ({{ (row.cnyExtraCharge || 0) | currency }})
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.productNo }}
                  <small
                    v-if="
                      row.customerProductNo != null &&
                      row.customerProductNo != ''
                    "
                    >({{ row.customerProductNo }})</small
                  >
                  <div class="font10">
                    {{ row.categoryName }}
                    <span v-if="row.productBrand != null">/</span>
                    {{ row.productBrand }}
                  </div>
                  <div class="font10">{{ row.color }} {{ row.size }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit }}
                </template>
              </vxe-table-column>
              <vxe-table-column :title="$t('order.dealType')" min-width="80">
                <template v-slot="{ row }">
                  <span v-if="row.dealType !== null">{{
                    $t("orderDealTypes." + row.dealType)
                  }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                :title="$t('bargain.saleAmount')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.cnyProductPrice | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column :title="$t('product.costPrice')" min-width="80">
                <template v-slot="{ row }">
                  {{ row.costPrice | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                :title="$t('product.productCostPrice')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.productCostPrice | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="handOverAt"
                :title="$t('text.handOverAt')"
                min-width="80"
              ></vxe-table-column>
              <vxe-table-column
                field="createAt"
                :title="$t('text.createAt')"
                min-width="80"
              />
              <vxe-table-column
                field="confirmAt"
                :title="$t('order.confirmAt')"
                min-width="80"
              />
              <vxe-table-column
                field="deliverAt"
                :title="$t('delivery.deliverAt')"
                min-width="80"
              />
              <vxe-table-column
                field="shopName"
                :title="$t('menu.shops')"
                min-width="80"
              ></vxe-table-column>
              <vxe-table-column
                field="ownerName"
                :title="$t('text.owner')"
                min-width="80"
              ></vxe-table-column>
            </vxe-table>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('bargain.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="productAmount"
          :title="$t('bargain.saleAmount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.productAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="cnyAmount"
          :title="$t('bargain.amount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.cnyAmount | currency }}
          </template>
        </vxe-table-column>

        <vxe-table-colgroup :title="'产品成本'">
          <vxe-table-column
            field="purchaseAmount"
            :title="'外采额'"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.purchaseAmount | currency }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="availableAmount"
            :title="'出库产品额'"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.availableAmount | currency }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="manufactureAmount"
            :title="'生产成本额'"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.manufactureAmount | currency }}
            </template>
          </vxe-table-column>
        </vxe-table-colgroup>
        <vxe-table-column
          field="deliverCostAmount"
          :title="'发货成本'"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.deliverCostAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="profitAmount" :title="'利润'" min-width="80">
          <template v-slot="{ row }">
            {{ row.profitAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="marginRate" :title="'毛利率'" min-width="80">
          <template v-slot="{ row }"> {{ row.marginRate }}% </template>
        </vxe-table-column>
        <vxe-table-column
          field="shopName"
          :title="$t('menu.shops')"
          min-width="80"
        />
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";

import User from "@/api/user";
import Shop from "@/api/shop";
import Bargain from "@/api/bargain";
import Color from "@/api/color";
import Supplier from "@/api/supplier";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange, Currency },
  data() {
    return {
      searchForm: {
        bargainCreateAtStartAt: null,
        bargainCreateAtEndAt: null,
        deliverAtStartAt: null,
        deliverAtEndAt: null,
        shopIds: [],
        ownerIds: [],
        rankBy: "salesAmount",
        productNo: null,
        color: null,
        productNo: null,
        supplierId: null,

        _dateType: "createAt",
        _dataRange: null,
        _dataRangeStartAt: null,
        _dataRangeEndAt: null,
      },
      users: [],
      shops: [],
      payMethods: [],
      colors: [],
      suppliers: [],
      //
      records: [],
      loading: false,
      count: null,
      actionPageDF: false,
    };
  },

  created() {
    const self = this;
    axios
      .all([
        Shop.findByTenantId(),
        User.findByTenantId(),
        Color.findByTenantId(),
        Supplier.findByTenantId(self.Permit.currentTenant().id),
      ])
      .then(
        axios.spread(function (shops, users, colors, suppliers) {
          if (shops.status == 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
          if (users.status == 200) {
            const allUsers = users.data.filter(
              (u) =>
                (u.voidAt == null && u.authorize == true) || u.voidAt != null
            );
            if (self.Permit.currentUser().admin === true) {
              self.users = allUsers;
            } else {
              self.users = allUsers.filter((u) =>
                JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
              );
            }
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          if (suppliers.status === 200) {
            self.suppliers = suppliers.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    // 颜色
    querySearchColor(queryString, cb) {
      const colors = this.colors.map((c) => {
        return { value: c.name };
      });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor() {
      this.searchForm.color = Util.jyTrim(this.searchForm.color);
    },
    //
    download() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Bargain.costProfitReportExportExcel(self.combineParams()).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedRows = [];
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //
    loadData() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Bargain.costProfitReport(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data.records;
          self.pager.total = res.data.total;
          self.getTotal();
        } else {
          self.sysError();
        }
      });
    },
    getTotal() {
      const self = this;
      if (self.actionPageDF) {
        return;
      }
      Bargain.costProfitReportCount(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.count = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.actionPageDF = true;
      this.loadData();
    },
    combineParams() {
      const self = this;
      self.searchForm.bargainCreateAtStartAt = null;
      self.searchForm.bargainCreateAtEndAt = null;
      self.searchForm.deliverAtStartAt = null;
      self.searchForm.deliverAtEndAt = null;

      if (self.searchForm._dateType == "createAt") {
        self.searchForm.bargainCreateAtStartAt =
          self.searchForm._dataRangeStartAt;
        self.searchForm.bargainCreateAtEndAt = self.searchForm._dataRangeEndAt;
      }
      if (self.searchForm._dateType == "deliverAt") {
        self.searchForm.deliverAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.deliverAtEndAt = self.searchForm._dataRangeEndAt;
      }
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>